var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2,41.9,83.3,20.6a11.9,11.9,0,0,0-10-5.3H26.7a11.9,11.9,0,0,0-10,5.3L2.8,41.9A17.6,17.6,0,0,0,0,51.4V73.2a11.6,11.6,0,0,0,3.4,8.2,11.9,11.9,0,0,0,8.1,3.3h77a11.9,11.9,0,0,0,8.1-3.3,11.6,11.6,0,0,0,3.4-8.2V51.4A17.6,17.6,0,0,0,97.2,41.9ZM8.8,45.3,22.7,24.1A4.7,4.7,0,0,1,26.5,22h47a4.7,4.7,0,0,1,3.8,2.1L91.2,45.3l.3.5H61.9l-.7,2A10.7,10.7,0,0,1,57,53.6a11.5,11.5,0,0,1-7,2.3,11.3,11.3,0,0,1-7-2.3,10.7,10.7,0,0,1-4.2-5.8l-.7-2H8.5ZM93.2,73.7A4.3,4.3,0,0,1,89.1,78H12.6a4.1,4.1,0,0,1-2.9-1.3,4.1,4.1,0,0,1-1.2-3V52.5H35a17.3,17.3,0,0,0,31.7,0H93.2V73.7Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.cc14b65e8ff728b851ad5fc068acee28.svg";
export { ForwardRef as ReactComponent };